var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAchievement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.82,
    height: 19.375,
    viewBox: "0 0 13.82 19.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.092,1.046,12.071,0,10.05,1.046,7.8,1.387,6.78,3.422,5.162,5.02l.37,2.245L5.161,9.51l1.619,1.6L7.8,13.143l2.25.341,2.021,1.047,2.021-1.046,2.25-.341,1.019-2.034,1.619-1.6-.37-2.245.371-2.245-1.619-1.6L16.343,1.388ZM15.54,2.491l-1.828-.277-1.641-.85-1.641.85L8.6,2.49,7.773,4.143l-1.315,1.3.3,1.824-.3,1.824,1.316,1.3L8.6,12.04l1.828.277,1.641.85,1.642-.85,1.827-.277.828-1.653,1.315-1.3-.3-1.824.3-1.824-1.315-1.3L15.54,2.491Z",
    transform: "translate(0)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,26.537v5.093l4.844-1.211,4.844,1.211V26.536l-2.443.371-2.4,1.243-2.4-1.243Z",
    transform: "translate(-1.773 -12.254)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievement);
export default __webpack_public_path__ + "static/media/achievement.3ae2de6bb316710a4359d816f31e4167.svg";
export { ForwardRef as ReactComponent };